import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

interface EmptyStateProps {
  icon?: LucideIcon
  title: ReactNode
  description?: ReactNode
  /** The next step, usually one primary button. */
  action?: ReactNode
  className?: string
  /** Compact variant for use inside cards and tables. */
  compact?: boolean
}

/** Shown when a list or page has nothing yet. Say what belongs here and how to add it. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  compact,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        compact ? 'px-4 py-8' : 'px-6 py-16',
        className,
      )}
    >
      {Icon && (
        <div className="mb-3 grid size-10 place-items-center rounded-lg border border-line bg-surface-2 text-ink-3">
          <Icon className="size-5" strokeWidth={1.75} />
        </div>
      )}
      <h3 className="text-base font-semibold text-ink">{title}</h3>
      {description && <p className="mt-1 max-w-md text-sm text-ink-2">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
